import { Plugin, PluginKey } from "prosemirror-state";
const trailingNodePluginKey = new PluginKey("trailingParagraph");
export function trailingParagraphPlugin(nodeType, ensureBlank = false) {
    return new Plugin({
        key: trailingNodePluginKey,
        appendTransaction(_, __, state) {
            const { doc, tr } = state;
            const pluginShouldInsertNodeAtEnd = trailingNodePluginKey.getState(state);
            if (!pluginShouldInsertNodeAtEnd) {
                return;
            }
            return tr.insert(doc.content.size, nodeType.create());
        },
        state: {
            init: (_, state) => {
                return shouldInsertNodeAtEnd(state.doc, nodeType, ensureBlank);
            },
            apply: (tr, value) => {
                if (!tr.docChanged) {
                    return value;
                }
                return shouldInsertNodeAtEnd(tr.doc, nodeType, ensureBlank);
            },
        },
    });
}
const shouldInsertNodeAtEnd = (doc, nodeType, ensureBlank = false) => {
    const lastChild = doc.lastChild;
    return (lastChild.type !== nodeType || (ensureBlank && !!lastChild.textContent));
};
